import { ReactNode, SyntheticEvent } from 'react';
import styled from 'styled-components';
import { BUTTON_SIZES, GhostButton } from 'ui/button';
import { ChevronLeftSmall } from 'ui/icons/navigation/ChevronLeftSmall';
import { spacing } from 'ui/theme';
import { DataSet } from './types';

const Container = styled.div`
  display: flex;
  align-items: center;
`;

const StyledGhostButton = styled(GhostButton)`
  padding: 0 ${spacing.half};
  margin-right: ${spacing.threeQuarter};
`;

type ModalBackButtonProps = {
  children?: ReactNode;
  onClick: (e?: SyntheticEvent) => void;
};

export const ModalBackButton = ({ children, onClick }: ModalBackButtonProps) => (
  <Container>
    <StyledGhostButton
      data-test={DataSet.ModalBackButtonTestId}
      onClick={onClick}
      size={BUTTON_SIZES.LARGE}
    >
      <ChevronLeftSmall height={24} width={24} />
    </StyledGhostButton>
    {children}
  </Container>
);
